angular.module('leanlaw').controller('OriginatingAttorneyDetailCtrl', ['$scope', '$rootScope', '$q', '$filter', '$state', '$stateParams', "alerts", 'userService', 'reportsService', 'leanLawApi', 'singleRequest', 'accountingService', "exportJson", "messageBus", function ($scope, $rootScope, $q, $filter, $state, $stateParams, alerts, userService, reportsService, leanLawApi, singleRequest, accountingService, exportJson, messageBus) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.loading = true;
  $scope.print = function () {
    window.print();
  };
  $scope.open = function (clientId, matterId) {
    $state.go('reports.originating-attorney-invoices', {
      accountId: $stateParams.id,
      clientId,
      matterId
    });
  };
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filtered.reduce((accum, c) => {
      let item = {};
      if ($scope.clientReferences || $scope.references) {
        if ($scope.filter.include && $scope.filter.include.matters) {
          item = {
            "ID": c.client.reference || "",
            "Client": c.client.name,
            [matter]: "",
            "Collected": $filter("amount")(c.data.collected.servicesTotal)
          };
        } else {
          item = {
            "ID": c.client.reference || "",
            "Client": c.client.name,
            "Collected": $filter("amount")(c.data.collected.servicesTotal)
          };
        }
      } else if ($scope.filter.include && $scope.filter.include.matters) {
        if ($scope.filter.show.billed) {
          item = {
            "Client": c.client.name,
            [matter]: "",
            "Collected": $filter("amount")(c.data.collected.servicesTotal)
          };
        } else {
          item = {
            "Client": c.client.name,
            [matter]: "",
            "Collected": $filter("amount")(c.data.collected.servicesTotal)
          };
        }
      } else {
        item = {
          "Client": c.client.name,
          "Collected": $filter("amount")(c.data.collected.servicesTotal)
        };
      }
      accum.push(item);
      if ($scope.filter.include && $scope.filter.include.matters) {
        c.matters.forEach(m => {
          let matterItem = {};
          matterItem = {
            "ID": m.matter.reference ? !isNaN(m.matter.reference) ? `="${m.matter.reference}"` : m.matter.reference : '',
            "Client": "",
            [matter]: m.matter.name,
            "Collected": $filter("amount")(m.data.collected.servicesTotal)
          };
          accum.push(matterItem);
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  activate();

  ///////////////////////////////////////

  function activate() {
    $q.all([userService.me(), leanLawApi.getAccount({
      id: $stateParams.id
    })]).then(([me, user]) => {
      $scope.me = me;
      $scope.user = user;
      accountingService.verify(false).then(status => {
        $scope.accounting = status.connected;
        $scope.$on('commonFilterService-statechanged', (event, payload) => {
          if (!payload) return;
          // Assigning to existing filter keeps custom filter options
          $scope.filter = Object.assign($scope.filter, payload);
          // Necessary to set this value for the requests
          $scope.filter.status = $scope.filter.archived.status;
          $scope.filter.scope = $scope.filter.filter.scope;
          if (payload.filter.range) {
            filterClientEntries();
          }
        });
        $scope.$on("report-sidebar-filterchange", (event, payload) => {
          $scope.filter = Object.assign($scope.filter, payload);
        });

        // MessageBus is used here so that the commonFilter module can pick it up once it loads
        messageBus.addMessage("filterDependency-ready", true);
      });
    });
  }
  let localCancelReport = null;
  function filterClientEntries() {
    if (localCancelReport) {
      localCancelReport.resolve("reloading");
    }
    localCancelReport = $q.defer();
    const query = reportsService.queryFromFilter($scope.filter);
    query.scopeAccount = $scope.user.id;
    query.data = "payments";
    query.scope = 'originating';
    query.billingType = '-internal';
    query.primary = 'clients';
    query.zeros = false;
    query.$timeout = localCancelReport.promise;
    query.reportType = 'revenue';
    $scope.loading = true;
    singleRequest.apiCall("report").getReport(query).then(data => {
      if (!data) return; // happens if we were canceled
      $scope.loading = false;
      $scope.data = data;
      $scope.references = data.clients.some(c => c.matters.some(m => m.matter.reference));
      $scope.clientReferences = data.clients.some(c => c.client.reference);
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("report");
    deactivate();
  });
  $scope.$watch("loading", newValue => console.log("l", newValue));

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filtered = $filter('orderBy')($filter('filter')($scope.data.clients, $scope.search), $scope.sort, $scope.reverse) || [];
    $scope.data.filtered.forEach(client => {
      client.filteredMatters = $filter('orderBy')($filter('filter')(client.matters, $scope.q), $scope.sort, $scope.reverse) || [];
    });
  }
  $scope.$watch('data.clients', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);